export default class ItemsRent {
    constructor() {
        this.id = "";
        this.groupRent = { id: "", content: "" };
        this.typeProduct = { id: "", content: "" };
        this.product = { id: "", content: "" };
        this.productId = "";
        this.periodRent = { id: "", content: "" };
        this.periodRentId = "";
        this.description = "";
        this.quantity = 1;
        this.unitValue = 0;
        this.unitCost = 0;
        this.discount = { discountByPercentage: false, discount: 0 };
        this.discountByPercentage = false;
        this.unitDiscount = 0;
        this.unitInsurance = 0;
        this.statusStockItemsRent = 0;
        this.onlyStock = false;
        this.optionSelectedDangerZone = "none";
        this.rentId = "";
        this.kitId = "";
        this.mainKit = false;
        this.itemsRentId = "";
        this.kitRentName = "";
        this.origin = "";
    }
    update(data) {
        this.id = data.id;
        this.groupRent = { id: data.subGroupId, content: data.subGroupName };
        this.typeProduct = { id: data.typeProductId, content: data.typeProductName };
        this.product = { id: data.productId, content: data.productName };
        this.productId = data.productId;
        this.periodRent = { id: data.periodRentId, content: data.periodRentName };
        this.periodRentId = data.periodRentId;
        this.description = data.description;
        this.quantity = data.quantity;
        this.unitValue = data.unitValue;
        this.unitCost = data.unitCost;
        this.discount = { discountByPercentage: false, discount: data.unitDiscount };
        this.unitInsurance = data.unitInsurance;
        this.statusStockItemsRent = data.statusStockItemsRent;
        this.statusInvoiceItemsRent = data.statusInvoiceItemsRent;
        this.onlyStock = data.onlyStock;
        this.rentId = data.rentId;
        this.kitId = data.kitId;
        this.itemsRentId = data.itemsRentId;
        this.kitRentName = data.kitRentName;
        this.mainKit = data.mainKit;
    }
}